module.exports = "mutation AddProductProviderField($data:AddProductProviderFieldInput!){addProductProviderField(data:$data){success}}"